import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { LanguageInputField, InlineLanguageInputField } from './LanguageInputField'
import { LanguageVariant } from './LanguageInput'

interface Props {
  variant?: LanguageVariant
  labelType?: 'text' | 'heading'
  label?: string
}

export const ConditionalLanguageInputField = (props: Props) => {
  const workspace = useCurrentWorkspace()

  if (workspace?.is_virtual_marketer === true) {
    return null
  }

  return <LanguageInputField {...props} />
}

export const ConditionalInlineLanguageInputField = ({ variant }: { variant?: LanguageVariant }) => {
  const workspace = useCurrentWorkspace()

  if (workspace?.is_virtual_marketer === true) {
    return null
  }

  return <InlineLanguageInputField variant={variant} />
}
